import React from 'react';
import clsx from 'clsx';
import { LuX } from 'react-icons/lu';

export type AlertType = 'info' | 'success' | 'warning';

interface AlertProps {
  title?: string;
  message: string;
  type?: AlertType;
  showing?: boolean;
  onClose?: () => void;
}

export const Alert = ({
  title,
  message,
  type = 'info',
  showing = true,
  onClose,
}: AlertProps) =>
  showing && (
    <div
      className={clsx(
        'relative flex flex-col gap-3 max-w-72 p-3 rounded-lg',
        type === 'info' && 'bg-blue-300 text-blue-700',
        type === 'success' && 'bg-green-300 text-green-700',
        type === 'warning' && 'bg-red-300 text-red-700',
      )}
    >
      <button
        className="absolute top-2 right-2 cursor-pointer"
        onClick={onClose}
        aria-label="Close Alert"
      >
        <LuX className="text-lg" />
      </button>

      {title && <h3 className="font-semibold">{title}</h3>}

      <p>{message}</p>
    </div>
  );
